import { render, staticRenderFns } from "./custom_what_we_do.vue?vue&type=template&id=3152815b&scoped=true&"
import script from "./custom_what_we_do.vue?vue&type=script&lang=js&"
export * from "./custom_what_we_do.vue?vue&type=script&lang=js&"
import style0 from "./custom_what_we_do.vue?vue&type=style&index=0&id=3152815b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152815b",
  null
  
)

export default component.exports